import { useContext } from "react"
import { useLocation } from "react-router"

import { WebBootContext } from "source/publishing/WebBoot"
import { extractMenuItems } from "source/shared/extractMenuItems"

export function useCustomNavigationLabel(fallback: string) {
  const state = useContext(WebBootContext)
  const { pathname } = useLocation()
  const menuItems = state.draftMode
    ? extractMenuItems(state.draftMenu)
    : extractMenuItems(state.publishedMenu)

  if (pathname.startsWith("/giving/profile")) {
    return fallback
  }

  const customTitle = menuItems.find((i) =>
    pathname.startsWith(i.href),
  )?.children
  return customTitle || fallback
}
